import { generateListTracking } from '../../utils/contentoUtils';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { listTrackingEvent } from '../../utils/statistics/customEvents';

export const trackGenrePageListClick = (event, itemPosition, svtId, selections) => {
    const eventData = {
        ...generateListTracking(selections),
        listItemIndex: itemPosition,
        contentId: svtId,
    };
    trackCustomEvent(listTrackingEvent(eventData, event.currentTarget));
};
